export const SET_MAIN_TABBAR_DATA = 'Main/set_main_tabbar_data'